import "@dana/Store/Data/OrderProgressLoading/Reducers/OrderProgressLoadingReducer";
import "@dana/Store/Data/AddCartLinesLoader/Reducers/AddCartLinesLoaderReducer";
import "@dana/Store/Data/AnnualReturnsCart/AnnualReturnsCartReducer";
import "@dana/Store/Data/BreadthRebateProgram/Reducers/BreadthRebateProgramReducer";
import "@dana/Store/Data/ChangeCustomers/Reducers/ChangeCustomerReducer";
import "@dana/Store/Data/CompatibleWithApplication/Reducers/CompatibleWithApplicationReducer";
import "@dana/Store/Data/DesktopMainNavigation/DesktopDrawerReducer";
import "@dana/Store/Data/EmergencyCart/EmergencyCartReducer";
import "@dana/Store/Data/InteractiveTool/Reducers/InteractiveToolReducer";
import "@dana/Store/Data/MyAccountMenu/Reducers/MyAccountMenuReducer";
import "@dana/Store/Data/MyProfile/Reducers/MyProfileReducer";
import "@dana/Store/Data/MyPublicProfile/Reducers/MyPublicProfileReducer";
import "@dana/Store/Data/MyVehicle/Reducers/MyVehicleReducer";
import "@dana/Store/Data/OpenOrders/Reducers/GetOpenOrdersDetailReducer";
import "@dana/Store/Data/OpenOrders/Reducers/GetOpenOrdersReducer";
import "@dana/Store/Data/OpenOrders/Reducers/PostCancelLinesReducer";
import "@dana/Store/Data/OrderHistory/Reducers/GetDanaInvoiceReducer";
import "@dana/Store/Data/OrderHistory/Reducers/GetShippingTrackingReducer";
import "@dana/Store/Data/OrderHistory/Reducers/GetDanaPackingSlipReducer";
import "@dana/Store/Data/OrderHistory/Reducers/GetDanaDeliveryNumbersReducer";
import "@dana/Store/Data/OrderVerify/Reducers/ResubmitOrderNumberToErpReducer";
import "@dana/Store/Data/ProductAvailability/Reducers/ProductAvailabilityReducer";
import "@dana/Store/Data/ProductAvailability/Reducers/SelectedInventryLocationsReducer";
import "@dana/Store/Data/ProductRelations/Reducers/BillToMaterialReducer";
import "@dana/Store/Data/ProductRelations/Reducers/WhereUsedReducer";
import "@dana/Store/Data/RealTimePriceLoading/Reducers/RealTimePriceLoadingReducer";
import "@dana/Store/Data/SearchVehicleFilter/Reducers/SearchVehicleReducer";
import "@dana/Store/Data/ShowPrice/Reducers/ShowPriceToggleReducer";
import "@dana/Store/Data/StandardReturns/Reducers/GetStandardReturnOrderReducer";
import "@dana/Store/Data/StandardReturnsStatus/Reducers/StandardReturnsStatusDetailsReducer";
import "@dana/Store/Data/StandardReturnsStatus/Reducers/StandardReturnsStatusReducer";
import "@dana/Store/Data/ViewCredit/Reducers/ViewCreditDetailsReducer";
import "@dana/Store/Data/ViewCredit/Reducers/ViewCreditReducer";
import "@dana/Store/Data/Warehouses/WarehousesReducer";
import "@dana/Store/Data/WishlistAvailability/Reducers/WishlistAvailabilityReducer";
import "@dana/Store/Pages/AnnualReturnsOrder/AnnualReturnsOrderReducer";
import "@dana/Store/Pages/OnePageCheckoutExt/OnePageCheckoutReducerExt";
import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";
// Importing nothing to trigger the side effects, which in this case adds custom reducers.
import CircleInfo from "@dana/Icons/CircleInfo";
import ChevronDown from "@dana/MobiusOverrides/Icons/ChevronDown";
import FirstPage from "@dana/MobiusOverrides/Icons/FirstPage";
import LastPage from "@dana/MobiusOverrides/Icons/LastPage";
import NextPage from "@dana/MobiusOverrides/Icons/NextPage";
import PreviousPage from "@dana/MobiusOverrides/Icons/PreviousPage";
import { elevation, gradients, themeBackgrounds, themeColors } from "@dana/MobiusOverrides/styles/colors";
import {
    fontFamilies,
    fontImportUrl,
    fontSizes,
    fontWeights,
    headings,
    lineHeights,
} from "@dana/MobiusOverrides/styles/typography";
import { setPreStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { IconWrapper } from "@insite/mobius/Icon";
import { StyledTypography } from "@insite/mobius/Link";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

// For production, include a set of commonly used widgets in the main bundle
// the rest will be split into their own chunks
// Do not do this for the ./Overrides folder
const widgets = IS_PRODUCTION
    ? require.context("./Widgets", true, /(Header|Basic|Common|Footer|SignIn)\/.+?\.tsx$/)
    : require.context("./Widgets", true, /\.tsx$/);
// enable hot module reloading for widgets
const onHotWidgetReplace = addWidgetsFromContext(widgets);
if (module.hot) {
    module.hot.accept(widgets.id.toString(), () => onHotWidgetReplace(require.context("./Widgets", true, /\.tsx$/)));
}

// Load all custom pages so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
const pages = require.context("./Pages", true, /\.tsx$/);
const onHotPageReplace = addPagesFromContext(pages);
if (module.hot) {
    module.hot.accept(pages.id.toString(), () => onHotPageReplace(require.context("./Pages", true, /\.tsx$/)));
}

// Load all handlers so they are included in the bundle.
const handlers = require.context("./Handlers", true);
handlers.keys().forEach(key => handlers(key));

// in production, the widget extensions are included in the chunks created for widgets
// if (!IS_PRODUCTION) {
// load all widget extensions. They could be loaded individually instead
const widgetExtensions = require.context("./WidgetExtensions", true);
widgetExtensions.keys().forEach(key => widgetExtensions(key));
// }

// add some post styleguide customizations. These can't be overridden by the style guide
setPreStyleGuideTheme({
    breakpoints: {
        keys: ["xs", "sm", "md", "lg", "xl"],
        values: [0, 450, 992, 992, 1440],
        maxWidths: [1440, 1440, 1440, 1440, 1440],
    },
    colors: {
        primary: {
            main: themeColors.primary.danaBlue,
        },
        success: {
            main: themeColors.secondary.danaBrightBlue,
        },
        common: {
            border: themeBackgrounds.lightGray,
        },
        text: {
            main: themeColors.primary.richBlack,
        },
        danger: {
            main: themeColors.danger
        },
    },
    modal: {
        sizeVariants: {
            small: 500,
            medium: 600,
            large: 800,
        },
        defaultProps: {
            cssOverrides: {
                modalTitle: css`
                    border: none;
                    position: relative;

                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    padding: 16px;
                                `,
                                css`
                                    padding: 16px;
                                `,
                                css`
                                    padding: 40px 40px 24px;
                                `,
                                css`
                                    padding: 40px 40px 24px;
                                `,
                            ],
                            "min",
                        )}
                `,
                modalContent: css`
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    padding: 16px;
                                `,
                                css`
                                    padding: 16px;
                                `,
                                css`
                                    padding: 0 40px 40px;
                                `,
                                css`
                                    padding: 0 40px 40px;
                                `,
                            ],
                            "min",
                        )}
                `,
            },
            closeButtonProps: {
                css: css`
                    position: absolute;
                    right: 8px;
                    top: 8px;
                    border: none;
                    padding: 4px;
                    min-height: auto;

                    &:hover {
                        border: none;
                    }
                `,
            },
            headlineTypographyProps: {
                variant: "h3",
            },
        },
    },
    button: {
        defaultProps: {
            css: css`
                display: inline-flex;
                justify-content: center;
                & > ${IconWrapper} {
                    width: 24px;
                    height: 24px;

                    svg {
                        width: 24px;
                        height: 24px;
                    }
                }
            `,
        },
        primary: {
            mergeCss: true,
            shape: "rectangle",
            color: themeColors.primary.danaBlue,
            hoverStyle: {
                background: themeColors.primary.white,
                color: themeColors.primary.danaBlue,
                border: `1px solid ${themeColors.primary.danaBlue}`,
            },
            activeStyle: {
                background: themeColors.primary.white,
                color: themeColors.primary.danaBlue,
                border: `1px solid ${themeColors.primary.danaBlue}`,
            },
            css: css`
                display: inline-flex;
                justify-content: center;
                border: 1px solid ${themeColors.primary.danaBlue};
                padding: 8px 24px;

                &.with-dark-bg {
                    display: none;
                }

                & > ${IconWrapper} {
                    width: 24px;
                    height: 24px;

                    svg {
                        width: 24px;
                        height: 24px;

                        path {
                            fill: ${themeColors.primary.white};
                        }
                    }
                }

                &:focus-visible {
                    background-color: ${themeColors.primary.white};
                    outline-offset: 2px;
                    outline-color: ${themeColors.secondary.danaDarkBlue};
                    outline-style: solid;
                    outline-width: 1px;
                }

                &:hover,
                &:focus-visible {
                    & > ${IconWrapper} {
                        svg {
                            path {
                                fill: ${themeColors.primary.danaBlue};
                            }
                        }
                    }

                    ${TypographyStyle} {
                        color: ${themeColors.primary.danaBlue};
                    }
                }

                &:disabled {
                    background: ${themeBackgrounds.lightGray};
                    color: ${themeBackgrounds.darkGray};
                    border: none;

                    ${TypographyStyle} {
                        color: ${themeBackgrounds.darkGray};
                    }

                    & > ${IconWrapper} {
                        svg {
                            path {
                                fill: ${themeBackgrounds.darkGray};
                            }
                        }
                    }
                }
            `,
            typographyProps: {
                color: themeColors.primary.white,
                size: fontSizes.medium,
                weight: fontWeights.medium,
                lineHeight: lineHeights.medium,
            },
        },
        secondary: {
            mergeCss: true,
            shape: "rectangle",
            color: themeColors.primary.white,
            hoverStyle: {
                background: themeColors.primary.danaBlue,
                color: themeColors.primary.white,
                border: `1px solid ${themeColors.primary.danaBlue}`,
            },
            activeStyle: {
                background: themeColors.primary.danaBlue,
                color: themeColors.primary.white,
                border: `1px solid ${themeColors.primary.danaBlue}`,
            },
            css: css`
                display: inline-flex;
                justify-content: center;
                border: 1px solid ${themeColors.primary.danaBlue};
                padding: 8px 24px;

                & > ${IconWrapper} {
                    width: 24px;
                    height: 24px;

                    svg {
                        width: 24px;
                        height: 24px;

                        path {
                            fill: ${themeColors.primary.danaBlue};
                        }
                    }
                }

                &:hover,
                &:focus-visible {
                    & > ${IconWrapper} {
                        svg {
                            path {
                                fill: ${themeColors.primary.white};
                            }
                        }
                    }

                    ${TypographyStyle} {
                        color: ${themeColors.primary.white};
                    }
                }

                &:focus-visible {
                    background-color: ${themeColors.primary.danaBlue};

                    ${TypographyStyle} {
                        color: ${themeColors.primary.white};
                    }
                }

                &:disabled {
                    background: ${themeBackgrounds.lightGray};
                    border: 1px solid ${themeBackgrounds.darkGray};

                    & > ${IconWrapper} {
                        svg {
                            path {
                                fill: ${themeBackgrounds.darkGray};
                            }
                        }
                    }

                    ${TypographyStyle} {
                        color: ${themeBackgrounds.darkGray};
                    }
                }
            `,
            typographyProps: {
                color: themeColors.primary.danaBlue,
                size: fontSizes.medium,
                weight: fontWeights.medium,
                lineHeight: lineHeights.medium,
            },
        },
        tertiary: {
            mergeCss: true,
            color: themeColors.primary.white,
            css: css`
                border: none;
                background: none;
                min-height: auto;
                padding: 0;

                &:hover,
                &:focus-visible,
                &:active {
                    background: none;
                    ${TypographyStyle} {
                        color: ${themeColors.secondary.danaDarkBlue};
                    }
                }

                &:disabled {
                    background: none;
                    ${TypographyStyle} {
                        color: ${themeBackgrounds.darkGray};
                    }
                }
            `,
            typographyProps: {
                color: themeColors.primary.danaBlue,
                underline: true,
                size: fontSizes.medium,
                weight: fontWeights.medium,
                lineHeight: lineHeights.medium,
            },
        },
    },
    focus: {
        color: themeColors.secondary.danaDarkBlue,
        style: "solid",
        width: "1px",
    },
    shadows: {
        1: "box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.10);",
        2: "0px 4px 16px 0px rgba(0, 0, 0, 0.20);",
    },
    link: {
        defaultProps: {
            color: themeColors.primary.danaBlue,
            mergeCss: true,
            hoverStyle: {
                color: themeColors.secondary.danaDarkBlue,
            },
            typographyProps: {
                mergeCss: true,
                css: css`
                    text-decoration: underline;
                `,
                underline: true,
            },
        },
    },
    typography: {
        fontFamilyImportUrl: fontImportUrl,
        body: {
            mergeCss: true,
            fontFamily: fontFamilies?.inter,
            size: fontSizes.medium,
            weight: fontWeights.regular,
            color: themeColors.primary.richBlack,
        },
        p: {
            size: fontSizes.medium,
            weight: fontWeights.regular,
        },
        h1: {
            color: themeColors.primary.richBlack,
            size: headings.h1.fontSize,
            lineHeight: headings.h1.lineHeight,
            weight: headings.h1.fontWeight,
            css: css`
                margin-bottom: 2rem;
                display: block;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                font-size: ${headings.h1.fontSizeSmall};
                                line-height: ${headings.h1.lineHeightSmall};
                            `,
                            null,
                            null,
                        ],
                        "max",
                    )}
            `,
        },
        h2: {
            color: themeColors.primary.richBlack,
            size: headings.h2.fontSize,
            lineHeight: headings.h2.lineHeight,
            weight: headings.h2.fontWeight,
            css: css`
                margin-bottom: 2rem;
                display: block;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                font-size: ${headings.h2.fontSizeSmall};
                                line-height: ${headings.h2.lineHeightSmall};
                            `,
                            null,
                            null,
                        ],
                        "max",
                    )}
            `,
        },
        h3: {
            color: themeColors.primary.richBlack,
            size: headings.h3.fontSize,
            lineHeight: headings.h3.lineHeight,
            weight: headings.h3.fontWeight,
            css: css`
                margin-bottom: 2rem;
                display: block;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                font-size: ${headings.h3.fontSizeSmall};
                                line-height: ${headings.h3.lineHeightSmall};
                            `,
                            null,
                            null,
                        ],
                        "max",
                    )}
            `,
        },
        h4: {
            color: themeColors.primary.richBlack,
            size: headings.h4.fontSize,
            lineHeight: headings.h4.lineHeight,
            weight: headings.h4.fontWeight,
            css: css`
                margin-bottom: 2rem;
                display: block;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                font-size: ${headings.h4.fontSizeSmall};
                                line-height: ${headings.h4.lineHeightSmall};
                            `,
                            null,
                            null,
                        ],
                        "max",
                    )}
            `,
        },
        h5: {
            color: themeBackgrounds.darkGray,
            size: headings.h5.fontSize,
            lineHeight: headings.h5.lineHeight,
            weight: headings.h5.fontWeight,
            transform: "uppercase",
            css: css`
                letter-spacing: 1.68px;
                margin-bottom: 2rem;
                display: block;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                font-size: ${headings.h5.fontSizeSmall};
                                line-height: ${headings.h5.lineHeightSmall};
                            `,
                            null,
                            null,
                        ],
                        "max",
                    )}
            `,
        },
    },
    header: {
        isFullWidth: true,
    },
    footer: {
        isFullWidth: true,
    },
    checkbox: {
        defaultProps: {
            color: themeColors.primary.danaBlue,
            indeterminateColor: themeColors.primary.danaBlue,
            mergeCss: true,
            css: css`
                &.checkboxChecked {
                    width: 100%;
                }

                span[role="checkbox"] {
                    border: 1px solid ${themeColors.primary.danaBlue};
                    width: 16px;
                    height: 16px;
                    justify-content: center;
                    margin-top: 0 !important;
                    flex-shrink: 0;

                    &:focus,
                    &:focus-visible {
                        box-shadow: none;
                        outline: 1px solid ${themeColors.secondary.danaDarkBlue};
                        outline-offset: 1px;
                    }

                    + label {
                        margin-left: 8px;
                        font-size: ${fontSizes.small};
                        line-height: ${lineHeights.defaultLarge};
                        font-weight: normal;
                        flex-grow: 1;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        align-items: flex-start;
                    }

                    svg {
                        width: 16px;
                        height: 16px;
                    }
                }
            `,
        },
        groupDefaultProps: {
            mergeCss: true,
            css: css`
                [data-id="checkbox"] {
                    align-items: center;
                }
            `,
        },
    },
    select: {
        defaultProps: {
            mergeCss: true,
            iconProps: {
                src: ChevronDown,
                size: 16,
            },
        },
    },
    fileUpload: {
        defaultProps: {},
    },
    textField: {
        defaultProps: {
            mergeCss: true,
            cssOverrides: {
                formField: css`
                    [class*="FormFieldLabel"] {
                        font-size: ${fontSizes.small};
                        line-height: ${lineHeights.small};
                        font-weight: ${fontWeights.semiBold};
                        letter-spacing: -0.68px;

                        + [class*="FormInputWrapper"] {
                            margin-top: 4px;
                        }
                    }

                    input:not(.react-datetime-picker__inputGroup__input),
                    select:not(.react-datetime-picker__inputGroup__input),
                    textarea,
                    .mobiusFileUpload {
                        border: 1px solid ${themeColors.primary.richBlack};
                        border-radius: 4px;
                        height: auto;
                        padding: 8px 16px;
                        font-size: ${fontSizes.medium};
                        line-height: ${lineHeights.medium};
                        color: ${themeColors.primary.richBlack};
                        &:focus,
                        &:focus-within {
                            border: 1px solid ${themeColors.primary.richBlack};
                            border-radius: 4px;
                            height: auto;
                            padding: 8px 16px;
                            color: ${themeColors.primary.richBlack};
                        }
                        &:focus-visible {
                            box-shadow: ${elevation.hover};
                            border: 1px solid ${themeColors.primary.danaBlue};
                        }

                        &:disabled {
                            background: ${themeBackgrounds.lightGray};
                            border: 1px solid ${themeBackgrounds.darkGray};
                            border-radius: 4px;
                            height: auto;
                            padding: 8px 16px;
                            color: ${themeBackgrounds.darkGray};
                            -webkit-text-fill-color: ${themeBackgrounds.darkGray};
                        }

                        &[aria-invalid="true"] {
                            border: 1px solid ${themeColors.danger};
                            border-radius: 4px;
                            height: auto;
                            padding: 8px 16px;

                            &:focus {
                                border: 1px solid ${themeBackgrounds.darkGray};
                                border-radius: 4px;
                                height: auto;
                                padding: 8px 16px;
                                color: ${themeColors.primary.richBlack};
                            }

                            & + [class*="DescriptionWrapper"],
                            & + [class*="IconWrapper"] + [class*="DescriptionWrapper"] {
                                margin-top: 4px;

                                [data-test-selector*="-error"] {
                                    color: ${themeColors.danger};
                                    font-weight: normal;
                                }
                            }
                        }
                    }

                    input:not(.react-datetime-picker__inputGroup__input),
                    textarea {
                    }

                    select:not(.react-datetime-picker__inputGroup__input) {
                        &:disabled {
                            background: ${themeColors.primary.white};
                            color: ${themeBackgrounds.darkGray};
                            -webkit-text-fill-color: ${themeBackgrounds.darkGray};

                            & + ${IconWrapper} {
                                background-color: ${themeColors.primary.white};
                            }
                        }
                    }
                `,
            },
        },
    },
    datePicker: {
        defaultProps: {
            mergeCss: true,
            cssOverrides: {
                datePicker: css`
                    .react-datetime-picker {
                        border: 1px solid ${themeColors.primary.richBlack};
                        border-radius: 4px;

                        &:focus,
                        &:focus-visible,
                        &:focus-within {
                            border: 1px solid ${themeColors.primary.danaBlue};
                            border-radius: 4px;
                            box-shadow: ${elevation.hover};
                        }
                    }
                `,
            },
        },
    },
    pagination: {
        defaultProps: {
            mergeCss: true,
            buttonProps: {
                color: themeColors.primary.white,
                size: 32,
                typographyProps: {
                    color: themeColors.primary.richBlack,
                },
                css: css`
                    width: 32px;
                    height: 32px;
                    padding: 4px 5px;
                    background: ${themeColors.primary.white};
                    border: 1px solid ${themeColors.primary.richBlack};
                    margin: 0;
                    min-height: auto;

                    &:disabled {
                        border: none;
                        background: transparent;
                    }

                    &:not(:disabled):hover {
                        color: ${themeColors.primary.white};
                        background: ${themeColors.primary.danaBlue};
                        border: 1px solid ${themeColors.primary.danaBlue};
                    }

                    ${TypographyStyle} {
                        color: ${themeColors.primary.richBlack};
                    }

                    &:hover {
                        ${TypographyStyle} {
                            color: ${themeColors.primary.white};
                        }
                    }
                `,
            },
            cssOverrides: {
                currentButton: css`
                    background: ${themeColors.primary.danaBlue};
                    border: 1px solid ${themeColors.primary.danaBlue};

                    ${TypographyStyle} {
                        color: ${themeColors.primary.white};
                    }
                `,
                arrowButtons: css`
                    width: auto;
                    height: auto;
                    padding: 0;
                    border: none;
                    background: transparent;

                    ${IconWrapper} {
                        width: auto;
                        height: auto;
                        top: 0;
                    }

                    &[data-test-selector="pagination_nextButton"],
                    &[data-test-selector="pagination_previousButton"] {
                        ${IconWrapper} {
                            svg {
                                width: 6px;
                                height: 11px;
                            }
                        }
                    }

                    &[data-test-selector="pagination_firstButton"],
                    &[data-test-selector="pagination_lastButton"] {
                        ${IconWrapper} {
                            svg {
                                width: 8px;
                                height: 9px;
                            }
                        }
                    }

                    &:disabled() {
                        ${IconWrapper} {
                            svg {
                                color: ${themeBackgrounds.darkGray};

                                path {
                                    fill: ${themeBackgrounds.darkGray};
                                }
                            }
                        }
                    }

                    &:not(:disabled) {
                        ${IconWrapper} {
                            svg {
                                color: ${themeColors.primary.richBlack};
                            }
                        }
                    }

                    ${({ theme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    width: 24px;
                                    height: 24px;
                                `,
                                null,
                                null,
                                null,
                                null,
                            ],
                            "min",
                        )};
                `,
                linkList: css`
                    ul {
                        display: flex;
                        align-items: center;
                        column-gap: 4px;
                    }
                `,
                pagination: css`
                    justify-content: center;
                `,
            },
            navIconsSrc: {
                firstPage: FirstPage,
                previousPage: PreviousPage,
                nextPage: NextPage,
                lastPage: LastPage,
            },
        },
    },
    radio: {
        defaultProps: {
            mergeCss: true,
            css: css`
                input {
                    & + label {
                        &::before {
                            border: 2px solid ${themeColors.primary.danaBlue};
                            width: 16px;
                            height: 16px;
                            border-radius: 0;
                            margin-right: 8px;
                        }
                    }
                    &:checked {
                        + label::after {
                            width: 8px;
                            height: 8px;
                            left: 4px;
                            top: 50%;
                            background: ${themeColors.primary.danaBlue};
                            transform: translateY(-50%);
                            border-radius: 0;
                        }
                        &:not(:disabled) {
                            & + label::before {
                                background: ${themeColors.primary.white};
                                border-color: ${themeColors.primary.danaBlue};
                            }
                        }
                    }
                    &:focus {
                        + label::before {
                            box-shadow: none;
                        }
                    }
                    &:disabled {
                        + label {
                            color: ${themeBackgrounds.darkGray};
                            &::before {
                                background: ${themeColors.primary.white};
                                border: 2px solid ${themeBackgrounds.darkGray} !important;
                            }

                            &::after {
                                background: ${themeColors.primary.white};
                            }
                        }
                    }
                }
            `,
        },
    },
    breadcrumbs: {
        defaultProps: {
            typographyProps: {
                lineHeight: lineHeights.default,
                size: fontSizes.small,
                css: css`
                    &[aria-current="page"] {
                        color: ${themeBackgrounds.darkGray};
                    }

                    @media print {
                        display: none;
                    }
                `,
            },
        },
    },
    lists: {
        unorderedListProps: {
            css: css`
                list-style: square;

                li {
                    &::marker {
                        color: ${themeColors.primary.danaBlue};
                    }
                }
            `,
        },
    },
    unorderedList: {
        defaultProps: {
            mergeCss: true,
            css: css`
                list-style: square;
            `,
        },
    },
    listItem: {
        defaultProps: {
            mergeCss: true,
            css: css`
                &::marker {
                    color: ${themeColors.primary.danaBlue};
                }
            `,
        },
    },
    accordion: {
        sectionDefaultProps: {
            mergeCss: true,
            headerProps: {
                css: css`
                    button {
                        background: ${themeColors.primary.white};
                        border: 1px solid ${themeBackgrounds.lightGray};

                        &,
                        &:focus-visible,
                        &:focus {
                            padding: 16px 24px;
                        }

                        &:hover,
                        &:focus,
                        &:focus-visible,
                        &[aria-expanded="true"] {
                            background: ${themeBackgrounds.lightGray};
                        }

                        &:focus,
                        &:focus-visible {
                            border-color: ${themeColors.primary.white};
                            outline: 1px solid ${themeColors.secondary.danaDarkBlue};
                        }

                        &:active {
                            outline: none;
                            border-color: ${themeBackgrounds.lightGray};
                        }

                        @media print {
                            display: flex !important;
                        }
                    }
                `,
            },
            titleTypographyProps: {
                variant: "h3",
                forwardAs: "h3",
                css: css`
                    margin-bottom: 0;
                `,
            },
            panelProps: {
                css: css`
                    border: 1px solid ${themeBackgrounds.lightGray};

                    @media print {
                        display: block !important;
                    }
                `,
            },
        },
    },
    tag: {
        defaultProps: {
            mergeCss: true,
            color: themeBackgrounds.darkGray,
            css: css`
                display: flex;
                align-items: center;
                min-height: 32px;
                padding: 8px;
                border-radius: 0;
                margin: 8px 8px 8px 0;

                button {
                    height: auto;
                    flex-basis: auto;
                    min-height: auto;
                    background: transparent;

                    &:hover {
                        background: transparent;
                        border: none;
                    }
                }

                &:hover {
                    background: ${themeColors.primary.richBlack};
                    button {
                        background: ${themeColors.primary.richBlack};
                    }
                }

                &:focus-visible {
                    border: 1px solid ${themeColors.primary.white};
                    box-shadow: ${elevation.focus};
                }
            `,
            typographyProps: {
                size: fontSizes.small,
                lineHeight: lineHeights.default,
            },
        },
    },
    tooltip: {
        defaultProps: {
            mergeCss: true,
            iconProps: {
                src: CircleInfo,
                size: 13,
            },
            cssOverrides: {
                tooltipContainer: css`
                    box-shadow: ${elevation?.hover};
                `,
                tooltipBody: css`
                    background: ${themeBackgrounds.white};
                    color: ${themeColors.primary.richBlack};
                `,
            },
        },
    },
    toast: {
        defaultProps: {
            closeButtonProps: {
                css: css`
                    position: absolute;
                    top: 0;
                    right: 0;
                    border: 0;
                    width: 47px;
                    height: 47px;
                    padding: 10px;

                    &:is(:hover, :active) {
                        border: none;
                    }
                `,
            },
            closeButtonIconProps: {
                color: themeColors.primary.richBlack,
            },
        },
    },
    loadingSpinner: {
        defaultProps: {
            css: css`
                color: ${themeColors.primary.danaBlue};
            `
        }
    },
    loadingOverlay: {
        defaultProps: {
            mergeCss: true,
            css: css`
                [class*="SpinnerWrapper"] {
                    top: calc(50% - 20px);
                    left: calc(50% - 20px);
                    right: calc(50% - 20px);
                    bottom: calc(50% - 20px);
                }
            `
        }
    },
    globalStyle: {
        css: css`
            :root {
                /* Mobile Spacing */
                --spacing-mobile-xlarge: 40px;
                --spacing-mobile-large: 32px;
                --spacing-mobile-medium: 24px;
                --spacing-mobile-small: 24px;
                --spacing-mobile-xsmall: 24px;
                --spacing-mobile-xxsmall: 16px;

                /* Default fallback spacing (mobile-first) */
                --spacing-xlarge: var(--spacing-mobile-xlarge);
                --spacing-large: var(--spacing-mobile-large);
                --spacing-medium: var(--spacing-mobile-medium);
                --spacing-small: var(--spacing-mobile-small);
                --spacing-xsmall: var(--spacing-mobile-xsmall);
                --spacing-xxsmall: var(--spacing-mobile-xxsmall);
            }

            /* Tablet Spacing */
            @media (min-width: 450px) {
                :root {
                    --spacing-xlarge: 64px;
                    --spacing-large: 40px;
                    --spacing-medium: 32px;
                    --spacing-small: 24px;
                    --spacing-xsmall: 24px;
                    --spacing-xxsmall: 16px;
                }
            }

            /* Desktop Spacing */
            @media (min-width: 991px) {
                :root {
                    --spacing-xlarge: 80px;
                    --spacing-large: 64px;
                    --spacing-medium: 40px;
                    --spacing-small: 32px;
                    --spacing-xsmall: 24px;
                    --spacing-xxsmall: 16px;
                }
            }

            /* Large Desktop Spacing */
            @media (min-width: 1440px) {
                :root {
                    --spacing-xlarge: 80px;
                    --spacing-large: 64px;
                    --spacing-medium: 40px;
                    --spacing-small: 32px;
                    --spacing-xsmall: 24px;
                    --spacing-xxsmall: 16px;
                }
            }

            /*
                Global Changes
            */

            /* Remove focus outline for mouse interactions */
            span[role="checkbox"]:not(:focus-visible) + label,
            [type="radio"]:not(:focus-visible) + label {
                outline: none !important;
                outline-offset: 0 !important;
            }

            html {
                scroll-behavior: smooth;
            }

            body {
                letter-spacing: -0.68px;
                line-height: 120%;
                overflow-x: hidden;
            }

            strong {
                font-weight: 600;
            }

            /* === Color Utilities === */
            .bg-black {
                background-color: ${themeBackgrounds.black};
            }

            .bg-white {
                background-color: ${themeBackgrounds.white};
            }

            .bg-darkgray {
                background-color: ${themeBackgrounds.darkGray};
            }
            .bg-lightgray {
                background-color: ${themeBackgrounds.lightGray};
            }

            .bg-offwhite {
                background-color: ${themeBackgrounds.offWhite};
            }

            .bg-primary-blue {
                background-color: ${themeColors.primary.danaBlue};
            }

            .bg-primary-rich-black {
                background-color: ${themeColors.primary.richBlack};
            }

            .bg-secondary-bright-blue {
                background-color: ${themeColors.secondary.danaBrightBlue};
            }

            .bg-secondary-dark-blue {
                background-color: ${themeColors.secondary.danaDarkBlue};
            }

            .bg-gradient {
                background: ${gradients.danaBlueGradient};
            }

            /* === Text Utilities === */
            .text-center {
                text-align: center;
            }

            .text-left {
                text-align: left;
            }

            .text-right {
                text-align: right;
            }

            .text-uppercase {
                text-transform: uppercase;
            }

            .text-lowercase {
                text-transform: lowercase;
            }

            .text-capitalize {
                text-transform: capitalize;
            }

            .font-regular {
                font-weight: 400;
            }

            .font-semibold {
                font-weight: 600;
            }

            .text-body-sm {
                &,
                ${TypographyStyle} {
                    font-size: ${fontSizes.small};
                    line-height: ${lineHeights.small};
                }
            }

            .text-body-md {
                &,
                ${TypographyStyle} {
                    font-size: ${fontSizes.medium};
                    line-height: ${lineHeights.medium};
                }
            }

            .text-body-lg {
                &,
                ${TypographyStyle} {
                    font-size: ${fontSizes.large};
                    line-height: ${lineHeights.large};
                }
            }

            .h1 {
                font-size: ${headings.h1.fontSize};
                line-height: ${headings.h1.lineHeight};
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                font-size: ${headings.h1.fontSizeSmall};
                                line-height: ${headings.h1.lineHeightSmall};
                            `,
                            null,
                            null,
                        ],
                        "max",
                    )}
            }

            .h2 {
                font-size: ${headings.h2.fontSize};
                line-height: ${headings.h2.lineHeight};
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                font-size: ${headings.h2.fontSizeSmall};
                                line-height: ${headings.h2.lineHeightSmall};
                            `,
                            null,
                            null,
                        ],
                        "max",
                    )}
            }
            .h3 {
                font-size: ${headings.h3.fontSize};
                line-height: ${headings.h3.lineHeight};
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                font-size: ${headings.h3.fontSizeSmall};
                                line-height: ${headings.h3.lineHeightSmall};
                            `,
                            null,
                            null,
                        ],
                        "max",
                    )}
            }

            .h4 {
                font-size: ${headings.h4.fontSize};
                line-height: ${headings.h4.lineHeight};
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                font-size: ${headings.h4.fontSizeSmall};
                                line-height: ${headings.h4.lineHeightSmall};
                            `,
                            null,
                            null,
                        ],
                        "max",
                    )}
            }

            .h5 {
                font-size: ${headings.h5.fontSize};
                line-height: ${headings.h5.lineHeight};
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                font-size: ${headings.h5.fontSizeSmall};
                                line-height: ${headings.h5.lineHeightSmall};
                            `,
                            null,
                            null,
                        ],
                        "max",
                    )}
            }

            .info-message-box {
                font-size: ${fontSizes.small};
                line-height: ${lineHeights.small};
            }

            .d-none {
                display: none !important;
            }

            .hide-on-tablet {
                @media screen and (min-width: 450px) and (max-width: 991px) {
                    display: none !important;
                }
            }

            .hide-on-mobile {
                @media screen and (max-width: 450px) {
                    display: none !important;
                }
            }

            .hide-on-desktop {
                @media screen and (min-width: 992px) {
                    display: none !important;
                }
            }

            a {
                color: ${themeColors.primary.danaBlue};
                text-decoration: underline;
            }

            a:hover,
            a:focus {
                color: ${themeColors.secondary.danaDarkBlue};
                text-decoration: underline;
                outline: none;
            }

            a:focus-visible {
                outline: 1px solid ${themeColors.secondary.danaDarkBlue};
                outline-offset: 2px;
                border-radius: 3px;
            }

            [data-test-selector="pageBreadcrumbs"] {
                flex-wrap: wrap;
                row-gap: 8px;

                @media print {
                    display: none;
                }
            }

            .btn {
                display: inline-flex;
                justify-content: center;
                align-items: center;
                gap: 10px;
                padding: 8px 24px;
                border: 1px solid ${themeColors.primary.danaBlue};
                font-size: ${fontSizes.medium};
                line-height: ${lineHeights.medium};
                font-weight: ${fontWeights.medium};

                &:focus-visible {
                    text-decoration: none;
                    outline-offset: 2px;
                    outline-style: solid;
                    outline-width: 1px;
                    border-radius: 0;
                }

                &:hover,
                &:active {
                    text-decoration: none;
                    ${StyledTypography} {
                        text-decoration: none;
                    }
                }

                & > ${StyledTypography} {
                    text-decoration: none;
                }

                @media print {
                    display: none;
                }

                &-primary {
                    background: ${themeColors.primary.danaBlue};

                    span[class*="StyledTypography"] {
                        color: ${themeBackgrounds.white};
                    }

                    &:hover,
                    &:active {
                        background: ${themeColors.primary.white};
                        text-decoration: none;

                        span[class*="StyledTypography"] {
                            color: ${themeColors.primary.danaBlue};
                            text-decoration: none;
                        }

                        ${IconWrapper} {
                            svg {
                                path {
                                    fill: ${themeColors.primary.danaBlue};
                                }
                            }
                        }
                    }

                    &:focus-visible {
                        background-color: ${themeColors.primary.white};
                        text-decoration: none;
                        outline-offset: 2px;
                        outline-color: ${themeColors.secondary.danaDarkBlue};
                        outline-style: solid;
                        outline-width: 1px;
                        border-radius: 0;

                        span[class*="StyledTypography"] {
                            color: ${themeColors.primary.danaBlue};
                            text-decoration: none;
                        }

                        ${IconWrapper} {
                            svg {
                                path {
                                    fill: ${themeColors.primary.danaBlue};
                                }
                            }
                        }
                    }

                    &:disabled {
                        background: ${themeBackgrounds.lightGray};
                        color: ${themeBackgrounds.darkGray};
                        border: none;

                        ${TypographyStyle} {
                            color: ${themeBackgrounds.darkGray};
                        }

                        ${IconWrapper} {
                            svg {
                                path {
                                    fill: ${themeBackgrounds.darkGray};
                                }
                            }
                        }
                    }
                }

                &-secondary {
                    background: ${themeColors.primary.white};

                    span[class*="StyledTypography"] {
                        color: ${themeColors.primary.danaBlue};
                    }

                    &:hover,
                    &:active {
                        background: ${themeColors.primary.danaBlue};
                        text-decoration: none;

                        span[class*="StyledTypography"] {
                            color: ${themeColors.primary.white};
                            text-decoration: none;
                        }
                    }

                    &:focus-visible {
                        background-color: ${themeColors.primary.danaBlue};
                        text-decoration: none;
                        outline-offset: 2px;
                        outline-color: ${themeColors.secondary.danaDarkBlue};
                        outline-style: solid;
                        outline-width: 1px;
                        border-radius: 0;

                        span[class*="StyledTypography"] {
                            color: ${themeColors.primary.white};
                            text-decoration: none;
                        }
                    }

                    &:disabled {
                        background: ${themeBackgrounds.lightGray};
                        border: 1px solid ${themeBackgrounds.darkGray};

                        ${StyledTypography} {
                            color: ${themeBackgrounds.darkGray};
                        }
                    }

                    &.icon-left {
                        &:hover {
                            &::before {
                                content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'%3E%3Cpath d='M10 13L5 8L10 3' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") !important;
                            }
                        }
                        &::before {
                            content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'%3E%3Cpath d='M10 13L5 8L10 3' stroke='%23C91E24' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") !important;
                        }
                    }

                    &.icon-right {
                        &:hover {
                            &::after {
                                content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'%3E%3Cpath d='M6 3L11 8L6 13' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") !important;
                            }
                        }
                        &::after {
                            content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='17' viewBox='0 0 16 17' fill='none'%3E%3Cpath d='M6 3.5L11 8.5L6 13.5' stroke='%23C91E24' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") !important;
                        }
                    }
                }

                &-tertiary {
                    padding: 8px 0px;
                    background: transparent;
                    border: 1px solid ${themeColors.primary.white};

                    ${StyledTypography} {
                        color: ${themeColors.primary.danaBlue};
                        text-decoration: underline;
                    }

                    &:hover {
                        text-decoration: underline;
                    }

                    &:focus-visible {
                        border: 1px solid ${themeColors.secondary.danaDarkBlue};
                        outline: none;
                        outline-offset: 0;

                        ${StyledTypography} {
                            color: ${themeColors.secondary.danaDarkBlue};
                            text-decoration: underline;
                        }
                    }

                    &:disabled {
                        ${StyledTypography} {
                            color: ${themeBackgrounds.darkGray};
                            text-decoration: underline;
                        }
                    }

                    &_small {
                        font-size: ${fontSizes.small};
                        line-height: ${lineHeights.defaultLarge};
                    }
                }
            }

            .btn-primary-dark {
                background: ${themeColors.secondary.danaBrightBlue};
                border: 1px solid ${themeColors.secondary.danaBrightBlue};

                span[class*="StyledTypography"],
                ${TypographyStyle} {
                    color: ${themeColors.primary.richBlack};
                }

                & > ${IconWrapper} {
                    svg {
                        path {
                            fill: ${themeColors.primary.richBlack};
                        }
                    }
                }

                &:hover {
                    background: ${themeColors.primary.richBlack};
                    span[class*="StyledTypography"] {
                        color: ${themeColors.secondary.danaBrightBlue};
                    }
                }
                &:focus-visible {
                    background: ${themeColors.primary.richBlack};
                    outline-color: ${themeColors.secondary.danaDarkBlue};

                    span[class*="StyledTypography"],
                    ${TypographyStyle} {
                        color: ${themeColors.secondary.danaBrightBlue};
                    }
                }
                &:disabled {
                    background: ${themeBackgrounds.lightGray};
                    color: ${themeBackgrounds.darkGray};
                    border: none;

                    ${TypographyStyle} {
                        color: ${themeBackgrounds.darkGray};
                    }
                }
            }

            .btn-secondary-dark {
                background: ${themeColors.primary.richBlack};
                border: 1px solid ${themeColors.secondary.danaBrightBlue};

                span[class*="StyledTypography"],
                ${TypographyStyle} {
                    color: ${themeColors.secondary.danaBrightBlue};
                }

                &:hover {
                    background: ${themeColors.secondary.danaBrightBlue};
                    span[class*="StyledTypography"],
                    ${TypographyStyle} {
                        color: ${themeColors.primary.white};
                    }
                }
                &:focus-visible {
                    background: ${themeColors.secondary.danaBrightBlue};
                    outline-color: ${themeColors.secondary.danaDarkBlue};
                    border-color: ${themeColors.primary.white};
                    outline-offset: 0;

                    span[class*="StyledTypography"],
                    ${TypographyStyle} {
                        color: ${themeColors.primary.white};
                    }
                }
                &:disabled {
                    background: ${themeBackgrounds.lightGray};
                    border: 1px solid ${themeBackgrounds.darkGray};

                    ${StyledTypography},
                    ${TypographyStyle} {
                        color: ${themeBackgrounds.darkGray};
                    }
                }
            }

            .btn-tertiary-dark {
                padding: 8px 0px;
                background: transparent;
                border: 1px solid ${themeColors.primary.richBlack};

                ${StyledTypography},
                ${TypographyStyle} {
                    color: ${themeColors.secondary.danaBrightBlue};
                    text-decoration: underline;
                }

                &:hover {
                    ${StyledTypography},
                    ${TypographyStyle} {
                        color: ${themeColors.primary.white};
                        text-decoration: underline;
                    }
                }

                &:focus-visible {
                    border: 1px solid ${themeColors.primary.white};
                    outline-offset: 0;

                    ${StyledTypography},
                    ${TypographyStyle} {
                        color: ${themeColors.primary.white};
                        text-decoration: underline;
                    }
                }

                &:disabled {
                    ${StyledTypography},
                    ${TypographyStyle} {
                        color: ${themeBackgrounds.darkGray};
                        text-decoration: underline;
                    }
                }
            }
            .btn-primary-white {
                background: ${themeColors.primary.white};
                border: 1px solid ${themeColors.primary.white};

                span[class*="StyledTypography"],
                ${TypographyStyle} {
                    color: ${themeColors.primary.richBlack};
                }

                & > ${IconWrapper} {
                    svg {
                        path {
                            fill: ${themeColors.primary.richBlack};
                        }
                    }
                }

                &:not(:disabled):hover {
                    background: ${themeColors.primary.richBlack};
                    border: 1px solid ${themeColors.primary.white};
                    span[class*="StyledTypography"],
                    ${TypographyStyle} {
                        color: ${themeColors.primary.white};
                    }
                }
                &:focus-visible {
                    background: ${themeColors.primary.richBlack};
                    outline-offset: 0;
                    outline-color: ${themeColors.secondary.danaDarkBlue};

                    span[class*="StyledTypography"],
                    ${TypographyStyle} {
                        color: ${themeColors.primary.white};
                    }
                }
                &:disabled {
                    background: ${themeBackgrounds.lightGray};
                    color: ${themeBackgrounds.darkGray};
                    border: none;

                    ${TypographyStyle} {
                        color: ${themeBackgrounds.darkGray};
                    }
                }
            }

            .btn-secondary-white {
                background: ${themeColors.primary.richBlack};
                border: 1px solid ${themeColors.primary.white};

                span[class*="StyledTypography"],
                ${TypographyStyle} {
                    color: ${themeColors.primary.white};
                }

                & > ${IconWrapper} {
                    svg {
                        path {
                            fill: ${themeColors.primary.white};
                        }
                    }
                }

                &:not(:disabled):hover {
                    background: ${themeColors.primary.white};
                    border: 1px solid ${themeColors.primary.white};
                    span[class*="StyledTypography"],
                    ${TypographyStyle} {
                        color: ${themeColors.primary.richBlack};
                    }
                }
                &:focus-visible {
                    background: ${themeColors.primary.white};
                    outline-offset: 0;
                    outline-color: ${themeColors.secondary.danaDarkBlue};

                    span[class*="StyledTypography"],
                    ${TypographyStyle} {
                        color: ${themeColors.primary.richBlack};
                    }
                }
                &:disabled {
                    background: ${themeBackgrounds.lightGray};
                    color: ${themeBackgrounds.darkGray};
                    border: none;

                    ${TypographyStyle} {
                        color: ${themeBackgrounds.darkGray};
                    }
                }
            }

            .page-row {
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                padding: 0 16px;
                                padding-bottom: 24px;
                            `,
                            css`
                                padding: 0 24px;
                                padding-bottom: 32px;
                            `,
                            css`
                                padding: 0 24px;
                                padding-bottom: 60px;
                            `,
                            css`
                                padding: 0 40px;
                                padding-bottom: 80px;
                            `,
                        ],
                        "min",
                    )}
            }

            .fakelink {
                position: absolute;
                left: -9999px;
                width: 1px;
                height: 1px;
                overflow: hidden;
                clip: rect(1px, 1px, 1px, 1px);
            }

            /* Order History Invoices Global Styles */
            .invoice_card {
                border: 1px solid ${themeBackgrounds.lightGray};

                &_header {
                    background: ${themeBackgrounds.lightGray};
                    padding: 4px;
                    font-weight: ${fontWeights.semiBold};
                }

                &_body {
                    padding: 4px;
                    background: ${themeBackgrounds.white};
                }
            }

            /* Chat Widget Styles */

            .embedded-messaging > .embeddedMessagingFrame[class~="isMaximized"] {
                @media screen and (max-width: 767px) {
                    bottom: 50px !important;
                }
            }

            .embedded-messaging > .embeddedMessagingFrame[class~="isMinimized"] {
                .minimizedButton {
                    outline: 2px solid ${themeColors.primary.danaBlue} !important;
                }
            }
            #react-app {
                .fullLoadingSpinner {
                    > [data-loading="true"][data-test-selector="loadingOverlaySpinner"] {
                        position: fixed;
                        top: 0;
                        left: 0;
                        margin: auto;
                        right: 0;
                        z-index: 9999;
                        [class*="SpinnerWrapper"] {
                            top: calc(50% - 20px);
                            left: auto;
                        }
                    }
                }
            }
            @media print {
                #onetrust-consent-sdk {
                    padding: 0 !important;
                }
                nav[data-test-selector="pageBreadcrumbs"] {
                    display: none;
                }
            }
        `,
    },
});
